export default (size) => {
  const sizeLowerCase = size.toLowerCase()

  const sizes = [
    // clothing
    'xxxs',
    'xxs',
    '2xs',
    'xs',
    's',
    'm',
    'l',
    'xl',
    'xxl',
    '2xl',
    '3xl',
    'xs-s',
    's-m',
    'm-l',
    'l-xl',
    // age
    '0-1y',
    '1-2y',
    '2-3y',
    '3-4y',
    '4-5y',
    '5-6y',
    '6-7y',
    'S (1-2Y)',
    'M (2-3Y)',
    // shoe
    '31/32',
    '33/34',
    '35/36',
    '37/38',
    '39/40',
    '41/42',
    // phone
    '15',
    '15 Plus',
    '15 Pro',
    '15 Pro Max',
    // inch
    '11"',
    '13"',
    '15"',
    // ml
    '2ml',
    '3ml',
    '5ml',
    '10ml',
    '18 ml.',
    '30ml',
    '50ml',
    '100ml',
    '150ml',
    '200ml',
    '500 ml.',
    // oz
    '8oz',
    '10oz',
    '12oz',
    '14oz',
    '16oz'
  ]

  const index = sizes.map((s) => s.toLowerCase()).indexOf(sizeLowerCase)

  if (index === -1 && Number(sizeLowerCase)) {
    return sizes.length + Number(sizeLowerCase)
  }

  return index + 1
}
